import { INIT_FAIL, INIT_SUCCESS, SEARCH_FAIL, SEARCH_SUCCESS } from "../actions/evaluationAnalysis";

const initialState = {
  evaluationList: [],
  rows: []
};
const evaluationAnalysis = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INIT_SUCCESS:
      return {
        ...state,
        evaluationList: payload.evaluationList
      };
    case INIT_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case SEARCH_SUCCESS:
      return {
        ...state,
        rows: payload.rows
      };
    case SEARCH_FAIL:
      return {
        ...state,
        error: payload.error
      };
    default:
      return {
        ...state
      };
  }
};

export default evaluationAnalysis;
